/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Typography, Button, SvgIconProps, Backdrop, CircularProgress } from '@mui/material';
import PageContainer from 'components/PageContainer/PageContainer';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { theme } from 'theme/theme';
import { alturaContainer, anchoMaxForms } from 'utils/constants';

interface RespuestaServidorProps {
  titulo: string;
  texto: React.ReactNode;
  paginaANavegar: number | string;
  icono: React.ComponentType<SvgIconProps> | null;
  textoBoton: string;
  colorBoton?: string;
  colorIcono?:
    | 'error'
    | 'disabled'
    | 'action'
    | 'inherit'
    | 'primary'
    | 'secondary'
    | 'info'
    | 'success'
    | 'warning'
    | undefined;
}

const RespuestaServidor = ({
  titulo,
  texto,
  icono: Icono,
  textoBoton,
  colorBoton,
  colorIcono,
  paginaANavegar,
}: RespuestaServidorProps) => {
  const navigate = useNavigate();
  const [openSpinner, setOpenSpinner] = React.useState(false);
  const handleClose = () => {
    setOpenSpinner(false);
  };
  const handleClick = () => {
    setOpenSpinner(true);
  };

  useEffect(() => {
    if (openSpinner) {
      // Necesita esta diferenciación aunque la operación sea la misma luego
      if (typeof paginaANavegar === 'number') {
        navigate(paginaANavegar);
      } else {
        navigate(paginaANavegar);
      }
    }
  }, [openSpinner]);

  return (
    <PageContainer marginBottom={true}>
      <Box
        textAlign="center"
        p={6}
        mx="auto"
        height={alturaContainer}
        display="flex"
        flexDirection="column"
        alignItems="center"
        maxWidth={500}
        width={anchoMaxForms}
      >
        <Typography variant="h5" pb={4}>
          {titulo}
        </Typography>
        <Typography variant="h6" fontSize="16px" color={theme.palette.primary.dark}>
          {texto}
        </Typography>
        {Icono && <Icono color={colorIcono} sx={{ pt: 4, fontSize: 40 }} />}
        <Button sx={{ mt: 4, backgroundColor: colorBoton }} variant="contained" onClick={handleClick}>
          {textoBoton}
        </Button>
        <Backdrop
          sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }}
          open={openSpinner}
          onClick={handleClose}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </Box>
    </PageContainer>
  );
};

export default RespuestaServidor;
